module.exports = __webpack_public_path__ + "static/DasaSans-Medium-9d02235827e7ae8687b6023d4fde51d4.ttf";